// extracted by mini-css-extract-plugin
export default {"tooltip":"HzqnMjv","label":"WPMO1eB","text":"d1m4UkN"};